import { Car } from "./car.entity"
import { User } from "./user"
import { Device } from "./device"
import { Base } from "./base"
import { WifiInfo } from './WifiInfo';

export class Datapackage {

  __iAm: string = "DataPackage"

  // onboarding = 1, else = 0
  initial: string = ""

  // Offline-Mode
  public offline: boolean = false

  // user, car
  type: string = ""

  // if applicable, else temp
  currentId: string = ""
  car: Car = new Car()

  device: Device = new Device('','','',WifiInfo.factory(),'','')

  user: User = new User()

  assignmode:string = '0'

  // imagedata as base64
  data: string = Base.DUMMY_PIC_URL

  context: string = ""

  status: string = "0"

  // calling controller
  origin:string = ""

  addcarback: string = ""

  photoboxOrigin:string = ""

  photoboxContinue:string = ""

  fleet: Car[] = []

  devices: Device[] = []

  workflow:string = "normal"  // createcar | onboarding | normal


}
